// extracted by mini-css-extract-plugin
export default {"container":"aJ-z","disabled":"bJ-z","bgBlack":"cJ-z","content":"dJ-z","countdown":"eJ-z","topCaption":"fJ-z","topHeading":"gJ-z","heading":"hJ-z","copy":"iJ-z"};